import { StateCreator } from 'zustand';

import { SentChatRepliesState, SentChatRepliesStore } from './types';

export const INITIAL_SENT_CHAT_REPLIES_STATE: SentChatRepliesState = {
  byEntryId: {},
};

export const createSentChatRepliesSlice: StateCreator<SentChatRepliesStore> = (
  set,
  get,
) => ({
  ...INITIAL_SENT_CHAT_REPLIES_STATE,

  recordSentReply: (inboxEntryId, reply) => {
    const { messageId } = reply.copy;
    if (get().byEntryId[inboxEntryId]?.[messageId]) {
      return false;
    }
    set((state) => ({
      byEntryId: {
        ...state.byEntryId,
        [inboxEntryId]: {
          ...state.byEntryId[inboxEntryId],
          [messageId]: reply,
        },
      },
    }));
    return true;
  },

  reset: () => set(INITIAL_SENT_CHAT_REPLIES_STATE),
});
